import React from "react";
import InboxThreadList from "../../components/InboxThreadList";
import InboxChatArea from "../../components/InboxChatArea";
import InboxSelector from "../../components/InboxSelector";
import InboxGroupSelector from "../../components/InboxGroupSelector";
import InboxHeader from "../../components/InboxHeader";
import { InboxChannelSelector } from "../../components/InboxChannelSelector";
import { useInbox } from "../../contexts/inbox";
import BreadcrumbWrapper from "../../components/BreadcrumbWrapper/index";
import { Switch } from "../../components/Switch/index";
import MobileInbox from "./MobileInbox";
import { useInboxMobileView } from "./useInboxMobileView";
import { useInboxUIStore } from "../../stores/inboxUIStore";

const InboxView = () => {
  // Get loading state and channel state from the inbox context
  const { loading, selectedChannel, setSelectedChannel } = useInbox();
  const { isMobileView, setIsMobileView } = useInboxMobileView();
  const isInboxHome = useInboxUIStore((state) => state.isInboxHome);
  const setIsInboxHome = useInboxUIStore((state) => state.setIsInboxHome);

  // Show loading spinner while data is being fetched
  if (loading) {
    return (
      <div className="flex h-[calc(100vh-64px)] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
      </div>
    );
  }

  if (isMobileView) {
    return <MobileInbox onExitMobileView={() => setIsMobileView(false)} />;
  }

  // Main UI
  return (
    // Bounded to the viewport less the topbar and main's padding, so the
    // thread list and conversation scroll internally instead of the page.
    <div className="flex h-[calc(100vh-6.5rem)] flex-col gap-4">
      <div className="flex items-center justify-between">
        <BreadcrumbWrapper crumbArray={[{ path: "/inbox", label: "Inbox" }]} />
        <div className="flex items-center gap-6">
          <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-600">
            Open at login
            <Switch checked={isInboxHome} onCheckedChange={setIsInboxHome} />
          </label>
          <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-600">
            Mobile view
            <Switch checked={isMobileView} onCheckedChange={setIsMobileView} />
          </label>
        </div>
      </div>
      <div className="px-4">
        <InboxChannelSelector
          selectedChannel={selectedChannel}
          onChannelChange={setSelectedChannel}
        />
      </div>
      <div className="flex min-h-0 flex-1">
        {/* Left column (1/3) with inbox info + thread list */}
        <div className="flex w-1/3 min-h-0 flex-col">
          <div className="mb-2 shrink-0 bg-gray-100 p-4">
            <div className="mb-3">
              <InboxSelector />
            </div>

            <InboxGroupSelector />

            <InboxHeader />
          </div>

          <InboxThreadList />
        </div>

        {/* Right column (2/3) with chat area */}
        <InboxChatArea />
      </div>
    </div>
  );
};

export default InboxView;
